define(['jquery'], function ($) {
    $(".btn.btn-site-search").click(function () {
        var keyword = $(".site-search input").val();
        if (keyword != "") {
            var url = [location.protocol, '//', location.host].join('');
            url = url + "/Site Search?keyword=" + encodeURIComponent(keyword);
            window.location.href = url;
        }

    })
    $(".site-search input").keypress(function (e) {
        if (e.which == 13) {
            var keyword = $(".site-search input").val();
            if (keyword != "") {
                var url = [location.protocol, '//', location.host].join('');
                url = url + "/Site Search?keyword=" + encodeURIComponent(keyword);
                window.location.href = url;
            }

            return false;
        }
    })
});